import { gql } from '@apollo/client';

const GET_LINE_ITEM_NOTES = gql`
  query GetLineItemNotes($lineItemId: String!) {
    getLineItemNotes(lineItemId: $lineItemId)
  }
`;

export default GET_LINE_ITEM_NOTES;
